export default __webpack_public_path__ + "static/media/cart-black.4a02f3cd.svg";